<template>
  <div class="patients-main">
    <div class="sub-header-box">
      <button class="btn-back" type="button" name="button" data-test="btnBack" @click="$router.back()">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>

      <nav style="--bs-breadcrumb-divider: '';" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/exam/" data-test="btnRouter">
              {{ $t('home') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('patient.patient') }}</li>
        </ol>
      </nav>
    </div>

    <div class="title-box">
      <div class="flex-start">
        <div>
          <button class="btn-back" type="button" name="button" data-test="btnBack" @click="goBack">
            <IconArrowBack/>
          </button>
          <h2 class="title">{{ $t('patient.newPatient') }}</h2>
        </div>
      </div>
    </div>

    <BaseTab :tabs="tabs" :initialtab="tabActive" @tab-activated="switchTab">
      <template v-slot:tab_head_data>
        {{ $t('patient.data') }}
      </template>
      <template v-slot:data>
        <PatientCreateTab v-if="tabActive == 'data'"></PatientCreateTab>
      </template>
    </BaseTab>
  </div>
</template>

<style lang="scss" scoped>
  .title-box {
    .btn-back {
      display:                     none;
    }
  }

  @media (max-width: 991px) {
    .sub-header-box,
    .title-box .btn-outline-secondary span {
      display:                     none !important;
    }
    .btn-back {
      display:                     flex;
    }
  }
</style>

<script>
import PatientCreateTab from './PatientCreateTab.vue'

export default {
  name: 'patient-create',
  components: {
    PatientCreateTab,
  },
  data: () => ({
    tabActive: 'data',
    tabs: ['data'],
    isHeaderMounted: false,
  }),
  mounted() {
    this.isHeaderMounted = true
  },
  methods: {
    switchTab(tab) {
      this.tabActive = tab;
    },
    goBack() {
      this.$router.push({name: 'patient-list'})
    },
  }
}
</script>
